import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IActivationServiceRequestTemplateModel } from '@apps-common/types/portal/service-request'

export const updateUnitActivationTemplate = async (
  model: IActivationServiceRequestTemplateModel
): Promise<IActivationServiceRequestTemplateModel> =>
  axios.post(`/UnitActivation/UpdateActivationTemplate`, model).then((res) => res?.data?.data)

type Props = {
  model: IActivationServiceRequestTemplateModel
}

export const useUpdateUnitActivationTemplate = (notify?: boolean, onSuccess?: (data: IActivationServiceRequestTemplateModel) => void) =>
  useMutation({
    mutationKey: ['updateUnitActivationTemplate'],
    mutationFn: ({ model }: Props) => updateUnitActivationTemplate(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated activation template.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update activation template, please try again.')
      }
    },
    throwOnError: false
  })
